// The prototype's seed users each carry a hex `color` — the real backend
// has no such field, so avatars need a deterministic-by-id fallback. Same
// trick used elsewhere in this codebase (see PROJ_COLORS/AVATAR_PALETTE):
// cycle a small brand-safe palette by id, not by list position, so a given
// user's color stays stable across pages/reloads without a lookup table.
const PALETTE = ['#226A73', '#4E7A24', '#8A5C08', '#5F9CA3', '#B23524', '#1F6570', '#7AB000', '#3C4148'];

export function avatarColor(id: number): string {
  return PALETTE[Math.abs(id) % PALETTE.length];
}

export function initials(name: string | null | undefined): string {
  return (
    (name || '')
      .trim()
      .split(/\s+/)
      .map((s) => s[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?'
  );
}
